/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { StaffUserRef } from './StaffUserRef';
import {
    StaffUserRefFromJSON,
    StaffUserRefFromJSONTyped,
    StaffUserRefToJSON,
    StaffUserRefToJSONTyped,
} from './StaffUserRef';
import type { FacilityRef } from './FacilityRef';
import {
    FacilityRefFromJSON,
    FacilityRefFromJSONTyped,
    FacilityRefToJSON,
    FacilityRefToJSONTyped,
} from './FacilityRef';
import type { MedicaidCaseStatus } from './MedicaidCaseStatus';
import {
    MedicaidCaseStatusFromJSON,
    MedicaidCaseStatusFromJSONTyped,
    MedicaidCaseStatusToJSON,
    MedicaidCaseStatusToJSONTyped,
} from './MedicaidCaseStatus';

/**
 * 
 * @export
 * @interface MedicaidCaseListRow
 */
export interface MedicaidCaseListRow {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    resident_name: string;
    /**
     * 
     */
    facility: FacilityRef;
    /**
     * 
     */
    owner: StaffUserRef | null;
    /**
     * 
     */
    status: MedicaidCaseStatus;
    /**
     * 
     */
    revision: number;
    /**
     * Secondary line under the status chip, e.g. "Request sent Oct 14"
     */
    status_caption: string | null;
    /**
     * What's holding it up, derived from open items
     */
    holding_up: string | null;
    /**
     * 
     */
    next_date: Date | null;
    /**
     * What next_date is, e.g. "Next reminder" or "Item due"
     */
    next_date_label: string | null;
    /**
     * 
     */
    admission_status: string | null;
    /**
     * 
     */
    updated_at: Date;
}



/**
 * Check if a given object implements the MedicaidCaseListRow interface.
 */
export function instanceOfMedicaidCaseListRow(value: object): value is MedicaidCaseListRow {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('resident_name' in value) || value['resident_name'] === undefined) return false;
    if (!('facility' in value) || value['facility'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('revision' in value) || value['revision'] === undefined) return false;
    if (!('status_caption' in value) || value['status_caption'] === undefined) return false;
    if (!('holding_up' in value) || value['holding_up'] === undefined) return false;
    if (!('next_date' in value) || value['next_date'] === undefined) return false;
    if (!('next_date_label' in value) || value['next_date_label'] === undefined) return false;
    if (!('admission_status' in value) || value['admission_status'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    return true;
}

export function MedicaidCaseListRowFromJSON(json: any): MedicaidCaseListRow {
    return MedicaidCaseListRowFromJSONTyped(json, false);
}

export function MedicaidCaseListRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicaidCaseListRow {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'resident_name': json['resident_name'],
        'facility': FacilityRefFromJSON(json['facility']),
        'owner': StaffUserRefFromJSON(json['owner']),
        'status': MedicaidCaseStatusFromJSON(json['status']),
        'revision': json['revision'],
        'status_caption': json['status_caption'],
        'holding_up': json['holding_up'],
        'next_date': (json['next_date'] == null ? null : parseDateTime(json['next_date'])),
        'next_date_label': json['next_date_label'],
        'admission_status': json['admission_status'],
        'updated_at': (json['updated_at'] == null ? json['updated_at'] : parseDateTime(json['updated_at'])),
    };
}

export function MedicaidCaseListRowToJSON(json: any): MedicaidCaseListRow {
    return MedicaidCaseListRowToJSONTyped(json, false);
}

export function MedicaidCaseListRowToJSONTyped(value?: MedicaidCaseListRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'resident_name': value['resident_name'],
        'facility': FacilityRefToJSON(value['facility']),
        'owner': StaffUserRefToJSON(value['owner']),
        'status': MedicaidCaseStatusToJSON(value['status']),
        'revision': value['revision'],
        'status_caption': value['status_caption'],
        'holding_up': value['holding_up'],
        'next_date': value['next_date'] == null ? value['next_date'] : serializeDateTime(value['next_date']),
        'next_date_label': value['next_date_label'],
        'admission_status': value['admission_status'],
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
    };
}

